import { AxiosResponse } from 'axios'
import { saveAs } from 'file-saver'
import { Axios } from 'src/service/axios/axios'
import { EnvironmentStore } from 'src/env/EnvironmentStore'

export const getDownloadFileName = (response: AxiosResponse): string => {
  const contentDisposition = response.headers['content-disposition']

  let fileName = ''

  if (contentDisposition) {
    const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
    if (fileNameMatch.length === 2) {
      fileName = fileNameMatch[1]
    }
  }
  return fileName
}

export const saveFileAs = (response: AxiosResponse): void => {
  // Blob data
  const data = response?.data
  // Filename is placed in the Content-Disposition header from backend, so we resolve it here
  const fileName = getDownloadFileName(response)
  // Saving the file using the saveAs function from file-saver
  saveAs(data, fileName)
}

export const saveFileAsWithFileName = (response: AxiosResponse, fileName: string): void => {
  saveAs(response?.data, fileName)
}

export const downloadFileByUrl = async (path: string): Promise<void> => {
  const backendUrl = EnvironmentStore.backendUrl

  await downloadBlobFile(`${backendUrl}/${path}`)
}

export const downloadBlobFile = (url: string) => {
  return Axios.getAxios()
    .get(url, { responseType: 'blob' })
    .then((response) => {
      saveFileAs(response)
    })
}

export const downloadBlobFileWithFileName = (url: string, fileName: string): Promise<void> => {
  return Axios.getAxios()
    .get(url, { responseType: 'blob' })
    .then((response) => {
      saveFileAsWithFileName(response, fileName)
    })
}
